import { Fragment, ReactNode, useEffect } from "react";
import * as ChatIcon from "../../static/img/chat-icon.png";
import "./css/webchat.scss";
import { useGetAvailableAgent } from "./useGetAvailableAgent";
import { configureWebchat, openChat } from "./webchatConfiguration";

interface IParams {
    children(props: { hasAvailableAgent: boolean; openChat(): void }): ReactNode;
}

export const Webchat = (props: IParams) => {
    const { children } = props;
    const hasAvailableAgent = useGetAvailableAgent();

    useEffect(configureWebchat, []);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment>{children({ hasAvailableAgent, openChat })}</Fragment>;
};

export const chatNow = (
    <Webchat>
        {({ hasAvailableAgent, openChat: onClick }) =>
            hasAvailableAgent && (
                // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                <div className="chat-now" onClick={onClick}>
                    Chat now <img alt="chat" src={ChatIcon} />
                </div>
            )
        }
    </Webchat>
);
